import { c as _c } from "react/compiler-runtime";
import type { PlayInfo } from '@module/apis/client-side/live/type';
import ItemsOnUsing from '@module/components/CommonBusiness/ItemsOnUsing';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import parseEnterChat from '@module/helpers/chat/parseEnterChat';
import useChatMessageStore from '@module/stores/useChatMessageStore';
import React, { type RefObject, useState } from 'react';
import ChatItem from './ChatItem';
import ChatListLayout from './ChatListLayout';
import IntroChat from './IntroChat';
import LoginIntro from './LoginIntro';
interface Props {
  playInfo: PlayInfo;
  isRoomMaster: boolean;
  isManager: boolean;
  scrollRef: RefObject<HTMLDivElement | null>;
}

/**
 * 채팅 메시지 리스트(읽기 관심사). 스크롤·인트로·enterChat·메시지 렌더만 담당한다.
 * 입력/전송(쓰기)은 형제 컴포넌트 ChatComposer가 가진다.
 */
function ChatMessageList(t0) {
  const $ = _c(34);
  const {
    playInfo,
    isRoomMaster,
    isManager,
    scrollRef
  } = t0;
  const {
    isLogin,
    rawLoginState
  } = useGetLoginInfoQuery();
  const chatMessages = useChatMessageStore(_temp);
  const [menuVisibleOffset, setMenuVisibleOffset] = useState(0);
  let t1;
  if ($[0] !== playInfo) {
    t1 = parseEnterChat(playInfo);
    $[0] = playInfo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const enterChat = t1;
  let t2;
  if ($[2] !== chatMessages.length || $[3] !== playInfo.chatMessage?.intro) {
    t2 = chatMessages.length < 100 && <IntroChat text={playInfo.chatMessage?.intro} />;
    $[2] = chatMessages.length;
    $[3] = playInfo.chatMessage?.intro;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${playInfo.media.userNick}님의 방송에 입장하셨습니다.`;
  let t4;
  if ($[5] !== t3) {
    t4 = <IntroChat text={t3} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isLogin || $[8] !== rawLoginState) {
    t5 = rawLoginState !== undefined && !isLogin && <LoginIntro />;
    $[7] = isLogin;
    $[8] = rawLoginState;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== enterChat || $[11] !== isManager || $[12] !== isRoomMaster || $[13] !== playInfo) {
    t6 = enterChat && <ChatItem item={enterChat} playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} />;
    $[10] = enterChat;
    $[11] = isManager;
    $[12] = isRoomMaster;
    $[13] = playInfo;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ItemsOnUsing />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== chatMessages || $[17] !== isManager || $[18] !== isRoomMaster || $[19] !== menuVisibleOffset || $[20] !== playInfo) {
    let t9;
    if ($[22] !== isManager || $[23] !== isRoomMaster || $[24] !== menuVisibleOffset || $[25] !== playInfo) {
      t9 = (item, index) => <React.Fragment key={"offset" in item && item.offset || "data" in item && "created_at" in item.data && item.data.created_at || index}><ChatItem item={item} userIdx={playInfo.media.userIdx} playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} menuVisibleOffset={menuVisibleOffset} setMenuVisibleOffset={setMenuVisibleOffset} /></React.Fragment>;
      $[22] = isManager;
      $[23] = isRoomMaster;
      $[24] = menuVisibleOffset;
      $[25] = playInfo;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    t8 = chatMessages.map(t9);
    $[16] = chatMessages;
    $[17] = isManager;
    $[18] = isRoomMaster;
    $[19] = menuVisibleOffset;
    $[20] = playInfo;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[27] !== scrollRef || $[28] !== t2 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t8) {
    t9 = <ChatListLayout scrollRef={scrollRef}>{t2}{t4}{t5}{t6}{t7}{t8}</ChatListLayout>;
    $[27] = scrollRef;
    $[28] = t2;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
}
function _temp(state) {
  return state.chatMessages;
}
export default ChatMessageList;